import { render, staticRenderFns } from "./PortraitSuggestions.vue?vue&type=template&id=70fc52c6&scoped=true&"
import script from "./PortraitSuggestions.vue?vue&type=script&lang=js&"
export * from "./PortraitSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./PortraitSuggestions.vue?vue&type=style&index=0&id=70fc52c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc52c6",
  null
  
)

export default component.exports